import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { BadgeColors, IssueCountBadge } from '../../../generic';
import type {
  SnippetIssueCounts,
  SnippetLicensingIssueCounts,
  SnippetSecurityIssueCounts,
} from '../../../../../shared/snippets';
import type { IssueCountBadgeProps } from '../../../generic/Badge/IssueCountBadge';

import styles from './IssueCounts.module.less';

function snippetLicensingIssueCountsToBadgeCounts(issueCounts: SnippetLicensingIssueCounts): IssueCountBadgeProps['issueTypes'] {
  return {
    policy_conflict: issueCounts.denied,
    policy_flag: issueCounts.flagged,
    unlicensed_dependency: issueCounts.unknown,
  };
}

function snippetSecurityIssueCountsToBadgeCounts(issueCounts: SnippetSecurityIssueCounts): IssueCountBadgeProps['issueTypes'] {
  return issueCounts;
}

export type Props = {
  id: string;
  isRejected: boolean;
  issueCounts: SnippetIssueCounts;
};

/**
 * Component which displays issue counts for a snippet.
 * This uses the newer "dots" design.
 */
const IssueCounts: VoidFunctionComponent<Props> = ({ id, isRejected, issueCounts }) => {
  if (isRejected) {
    return <div>Unavailable for rejected snippets</div>;
  }

  const totalLicensingIssues = _.sum(Object.values(issueCounts.licensing));
  const totalSecurityIssues = _.sum(Object.values(issueCounts.security));
  if (totalLicensingIssues === 0 && totalSecurityIssues === 0) {
    return <div>No issues found</div>;
  }

  return (
    <div className={styles.issueCountBadges}>
      {totalLicensingIssues > 0 && (
        <IssueCountBadge
          id={`snippet-or-package-${id}-licensing`}
          pluralLabel={() => 'licensing'}
          issueTypes={snippetLicensingIssueCountsToBadgeCounts(issueCounts.licensing)}
          color={BadgeColors.White}
        />
      )}
      {totalSecurityIssues > 0 && (
        <IssueCountBadge
          id={`snippet-or-package-${id}-security`}
          pluralLabel={() => 'security'}
          issueTypes={snippetSecurityIssueCountsToBadgeCounts(issueCounts.security)}
          color={BadgeColors.White}
        />
      )}
    </div>
  );
};

export default IssueCounts;
